import useTheme from 'branding/theme';
const useAutoInputStyles = () => {
    const { inputs } = useTheme();
    const styles = {
        ...inputs.base,
        ...inputs.width.full,
        ...inputs.size.regular,
        border: 'none',
        borderRadius: '2.6rem' // Ensure no visible overflow on browser autocomplete
    };
    return styles;
};
export default useAutoInputStyles;
//# sourceMappingURL=useAutoInputStyles.js.map